import React from "react";
import { Link } from "react-router-dom";
import { Badge, Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import { planIncludes, pricingTiers } from "./marketingData";
import "./marketing.css";

const Pricing = () => {
  return (
    <div className="tlm-home tlm-dark tlm-pricing-page min-vh-100 py-5">
      <Container>
        <Row className="mb-4 justify-content-center text-center">
          <Col lg="9">
            <p className="text-uppercase text-primary font-weight-bold small mb-2">
              TrackLastMile Pricing
            </p>
            <h1 className="font-weight-bold mb-3 text-dark">
              Simple pricing. Real numbers. No "contact us" games.
            </h1>
            <p className="tlm-text-muted tlm-pricing-lead mb-0 mx-auto">
              Choose the plan that matches your stage today, then scale without rebuilding your stack.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          {pricingTiers.map((plan) => (
            <Col lg="3" md="6" className="mb-4" key={plan.key}>
              <Card className={`h-100 tlm-card tlm-pricing-card border ${plan.featured ? "border-primary shadow" : "shadow-sm"}`}>
                <CardBody className="d-flex flex-column p-4">
                  <div className="mb-2">
                    <h2 className="h5 mb-1 d-inline-block text-dark">{plan.title}</h2>
                    {plan.badge ? (
                      <Badge color="primary" pill className="ml-2">
                        {plan.badge}
                      </Badge>
                    ) : null}
                  </div>
                  <p className="h5 mb-2 text-dark">{plan.price}</p>
                  <p className="tlm-text-muted mb-2">{plan.meter}</p>
                  <p className="tlm-text-muted mb-2">{plan.branding}</p>
                  <p className="tlm-text-muted mb-2">{plan.limit}</p>
                  <p className="tlm-text-muted mb-4">{plan.support}</p>
                  <Button
                    color={plan.featured ? "primary" : "outline-primary"}
                    tag={Link}
                    to={plan.ctaLink}
                    className="mt-auto"
                  >
                    {plan.ctaLabel}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
        <Row>
          <Col>
            <Card className="border-0 shadow-sm tlm-pricing-summary">
              <CardBody>
                <p className="mb-0 tlm-text-muted">{planIncludes}</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Pricing;
